import { useEffect, useState } from 'react';

export function getCosIDFromUrl(url: string): string {
  if (!url) {
    return '';
  }
  if (url.includes('.png')) {
    return url.split('.png')[0];
  }
  if (url.includes('.jpg')) {
    return url.split('.jpg')[0];
  }
  if (url.includes('.jpeg')) {
    return url.split('.jpeg')[0];
  }
  if (url.includes('.gif')) {
    return url.split('.gif')[0];
  }
  return '';
}

export function useImageCache(url: string) {
  const [href, setHref] = useState('');
  const [cosID, setCosID] = useState('');

  useEffect(() => {
    const id = getCosIDFromUrl(url);
    if (id !== cosID) {
      setCosID(id);
      setHref(url);
    }
  }, [url, cosID]);

  return [href];
}
